import React, { useEffect, useState, useRef } from "react";
import HeaderSearch from "./com/HeaderSearch";
import CardTable from "./com/CardTable";
import WidgetAjax from '../../widget/WidgetAjax';
import Config from "../../config/Config";
import eventBus from "../../frame/eventBus";
import { CaretDownOutlined } from '@ant-design/icons';

import './index.scss';

// 删掉外面全局读取url的四行代码！！！

const EnterpriseSearch = (props) => {
    const path = Config.getBasePath();
    const useInfo = JSON.parse(sessionStorage.getItem("_user_location_"));
    const [params, setParams] = useState({
        DISTRICT: useInfo?.value || undefined,
        word: undefined,
    });
    const [areaOptions, setAreaOptions] = useState([]);
    const [indType, setIndType] = useState([]);
    const [peopleOptions, setPeopleOptions] = useState([]);
    const [enterpriseType, setEnterpriseType] = useState([]);
    const [loading, setLoading] = useState(false);
    const [location, setlocation] = useState(useInfo);
    const [financing, setFinancing] = useState([]);
    const HeaderSearchRef = useRef();
    const [searchHeight, setSearchHeight] = useState(285);
    const enterpriseSearchRef = useRef(null);
    const [scrollTop, setScrollTop] = useState(0);
    // 存储实时url的word，传给HeaderSearch
    const [urlWord, setUrlWord] = useState('');

    const options = {
        placeholder: "搜索企业名称",
        labelWidth: '80px',
    };
    const conditionList = [
        { label: '所在区域', props: 'DISTRICT', options: areaOptions, valueProps: "code" },
        { label: '所属行业', props: 'INDTYPE', options: indType, valueProps: "value" },
        { label: '人员规模', props: 'SCALE', options: peopleOptions, valueProps: "value" },
        { label: '企业性质', props: 'ENTTYPE', options: enterpriseType, valueProps: "value" },
    ];

    // 【关键】每次组件渲染/路由切回，实时读取当前地址栏参数
    useEffect(() => {
        const searchStr = window.location.search;
        const urlParams = new URLSearchParams(searchStr);
        const currentWord = urlParams.get('word');
        
        setUrlWord(currentWord || undefined);

        if (currentWord) {
            // 初始化查询参数
            setParams(prev => ({
                ...prev,
                word: currentWord
            }));
           
        }
    }, [path]);

    // 检索
    const onSearch = (value) => {
        setParams({
            ...value,
            keyword: undefined,
            word: value.keyword,
            DISTRICT: value.DISTRICT && value.DISTRICT !== '' ? [value.DISTRICT] : (useInfo?.value ? [useInfo.value] : undefined),
            INDTYPE: value.INDTYPE && value.INDTYPE !== '' ? [value.INDTYPE] : undefined,
            SCALE: value.SCALE && value.SCALE !== '' ? [value.SCALE] : undefined,
            ENTTYPE: value.ENTTYPE && value.ENTTYPE !== '' ? [value.ENTTYPE] : undefined,
        })
    }
    // 获取地区
    const getArea = () => {
        setLoading(true);
        console.log(location);

        WidgetAjax.ajax({
            url: path + '/recruitment/area',
            params: {
                hierarchy: location?.level ? location.level + 1 : "2",
                parent_code: location?.value || "100000",
                rank: "4"
            },
            callback: (res) => {
                if (res.status == 0) {
                    setLoading(false);
                    setAreaOptions(res.results)
                }
            }
        })
    }
    // 获取维度
    const getDimension = (params) => {
        WidgetAjax.ajax({
            url: path + '/widget/dimension',
            params: params,
            callback: (res) => {
                if (res.status == 0) {
                    if (params.dimension == 'D200') {
                        setIndType(res.results[0].values[0].child.values)
                    } else if (params.dimension == 'D204') {
                        setPeopleOptions(res.results[0].values)
                    } else if (params.dimension == 'D203') {
                        setEnterpriseType(res.results[0].values)
                    }
                    setTimeout(() => {
                        if (HeaderSearchRef.current && HeaderSearchRef.current.dom) {
                            setSearchHeight(HeaderSearchRef.current.dom + 20)
                        }
                    }, 1000)
                }
            }
        })
    }
    // 监听定位地区的变化
    const locationChange = (location) => {
        setlocation(location);
    }

    useEffect(() => {
        Promise.allSettled([
            getDimension({
                dimension: "D200",
                hierarchy: 1,
            }),
            getDimension({
                dimension: "D204",
            }),
            getDimension({
                dimension: "D203",
            }),
        ]).then(res => {
            setLoading(false);
        })
        eventBus.on('locationChange', locationChange);
        return () => {
            eventBus.off('locationChange', locationChange);
        };
    }, []);
    // 获取页面滚动距离
    const getScrollHeight = () => {
        let dom = document.querySelectorAll('.sf-body.sd-body')[0];
        setScrollTop(dom.scrollTop);
    }

    useEffect(() => {
        getArea();
        setParams(prev => ({
            ...prev,
            DISTRICT: location && location.value ? [location?.value] : undefined
        }));
    }, [location]);

    useEffect(() => {
        let dom = document.querySelectorAll('.sf-body.sd-body')[0];
        dom.addEventListener('scroll', getScrollHeight);
        return () => dom.removeEventListener('scroll', getScrollHeight);
    }, []);

    return (
        <div
            className="enterprise_search"
            id="enterprise_search"
            component-data="enterprise-search"
        >
            <HeaderSearch
                onGetRefHeight={HeaderSearchRef}
                options={options}
                word={urlWord}
                conditionList={conditionList}
                onSearch={(value) => onSearch(value)}
                loading={loading}
                scrollTop={scrollTop}
            />
            <CardTable
                options={{
                    url: '/enterprise/search',
                }}
                params={params}
                history={props.history}
            />
        </div>
    )
}

export default EnterpriseSearch;
